import { Container, Row, Col } from "react-bootstrap";
import { MailchimpForm } from "./MailchimpForm";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">

          <MailchimpForm />

          <Col size={12} sm={6} className="text-center mx-auto">
            <p>Follow Me On</p>
            <div className="social-icon">
              <a href="https://www.linkedin.com/in/deepankar-sahu?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"><img src={navIcon1} alt="Icon" /></a>
              <a href="https://www.facebook.com/share/b4jbXTkywcVMpkGg/?mibextid=qi2Omg"><img src={navIcon2} alt="Icon" /></a>
              <a href="https://www.instagram.com/i_m_deepankar.advisior?utm_source=qr&igsh=NmU2ampucmE1MHdz"><img src={navIcon3} alt="Icon" /></a>
            </div>
            <p>Design & Developed By Deepankar Sahu</p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}
